import { createStyles } from "@envestnet/envreact-component-library";
import type { Theme, WithStyles } from "@envestnet/envreact-component-library";

const styles = (theme: Theme) =>
  createStyles({
    modalHeader: {
      ...theme.fonts.h4,
      color: theme.colors.textDefault,
      marginBottom: 0,
    },
    modalBody: {
      color: "var(--light-text-default, rgba(0, 0, 0, 0.85))",
      textAlign: "center",
      fontFamily: "Red Hat Text",
      fontSize: "14px",
      fontWeight: "lighter",
    },
  });

export type Styles = WithStyles<typeof styles>;
export default styles;
